/* eslint-disable @typescript-eslint/no-empty-interface,
jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import * as React from 'react';
import { Popover } from '@mui/material';

export interface PopoverComponentRef {
  close?: () => void;
  open?: () => void;
}

interface PopoverComponentProps {
  Component: JSX.Element;
  children: React.ReactNode | React.ReactNode[];
  controlled?: boolean;
}

const PopoverComponent = React.forwardRef<PopoverComponentRef, PopoverComponentProps>(
  (props: PopoverComponentProps, ref) => {
    const {
      children,
      Component,
      controlled,
    } = props;

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const popoverRef = React.useRef(null);
    const controlledButtonRef = React.useRef(null);

    const handleOpen = () => {
      if (controlledButtonRef.current) {
        setAnchorEl(controlledButtonRef.current);
      }
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    // Expose close method via ref
    React.useImperativeHandle(ref, () => ({
      close: handleClose,
      open: handleOpen,
    }));

    const open = Boolean(anchorEl);
    const id = open ? 'popover' : undefined;

    const PoperComponent = React.cloneElement(Component, {
      close: () => handleClose(),
    });

    return (
      <div>
        <div
          ref={controlledButtonRef}
          aria-describedby={id}
          onClick={!controlled ? handleClick : undefined}
        >
          {children}
        </div>
        <Popover
          ref={popoverRef}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
        >
          {PoperComponent}
        </Popover>
      </div>
    );
  },
);

PopoverComponent.defaultProps = {
  controlled: false,
};

PopoverComponent.propTypes = {

};

export default PopoverComponent;
